<template>
  <div>
    <div class="text-right pb-3 d-flex justify-space-between flex-column ma-n2 flex-md-row">
      <mko-index-filter
          :filter="options"
          @update:filter="filter => options = {...options, ...filter}"
          @change="() => {options.page = 1; onChangeFilter()}"
      />
      <div class="pa-2 flex-grow-1">
        <v-btn :width="$vuetify.breakpoint.smAndDown ? '100%' : null" v-if="isUserSuperAdmin"
               @click="$router.push({name: 'mko-create'})" class-name="action-btn"
               color="primary">
          <v-icon small class="mr-2">fas fa-plus</v-icon>
          Добавить новый
        </v-btn>
      </div>
    </div>
    <v-data-table
        disable-pagination
        :headers="headers"
        hide-default-footer
        :items="items">
      <template #item.status="{item}">
        <v-switch
            @change="changeBranchStatus(item)"
            :false-value="10"
            :loading="item.loading"
            :true-value="0"
            v-model="item.user.status"
        ></v-switch>
      </template>
      <template #item.seller_id="{item}">
        <v-chip class="ma-2" small :color="item.seller_id === 123456789 ? 'pink' : 'success'" label
                text-color="white">
          {{ item.seller_id }}
        </v-chip>
      </template>
      <template #item.uzcard_login="{item}">
        <v-icon small class="mr-2" color="success" v-if="item.uzcard_login && item.uzcard_pass">fas fa-check</v-icon>
      </template>
      <template #item.action="{item}">
        <div class="action-btn-wrap">
          <v-btn :to="mkoEdit(item.id)" class="action-btn" color="warning">
            <v-icon x-small>fas fa-pencil-alt</v-icon>
          </v-btn>
          <v-btn v-if="isUserSuperAdmin" @click="deleteItemHandler(item)" class="action-btn" color="error">
            <v-icon x-small>fas fa-trash</v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>
    <v-pagination
        @input="onChangeFilter"
        v-if="lastPage > 1"
        v-model="options.page"
        :length="lastPage"
    ></v-pagination>
    <warning-dialog
        @cancel="selectedItem = null"
        @apply="deleteItem"
        :description="`Вы действительно хотите удалить филиал ${selectedItem && selectedItem.name}?`"
        v-model="deleteConfirmDialog"
    ></warning-dialog>
    <warning-dialog
        @cancel="selectedItem = null"
        yes-delete-btn-text="Да все равно удалить"
        v-model="applyDeleteDialog"
        description="Перед удалением убедитесь отсутсвие активного кредита у этого филиала"
        @apply="deleteConfirmHandle"
    ></warning-dialog>
  </div>
</template>
<script>
import {messages, ROLES} from '@/utils/constants'
import WarningDialog from "@/components/ui/prompt/warning-dialog";
import MkoIndexFilter from "@/components/mko/MkoIndexFilter";
import {mapGetters} from "vuex";
import {getObjectValuesByKey, shallowEqual} from "@/utils/pureFunctions";

export default {
  components: {MkoIndexFilter, WarningDialog},
  data() {
    return {
      mkos: [],
      selectedItem: null,
      deleteConfirmDialog: false,
      items: [],
      options: {
        name: null,
        inn: null,
        page: 1
      },
      lastPage: 0,
      headers: [
        {
          text: 'Бренд',
          value: 'name'
        },
        {
          text: 'Название фирмы',
          value: 'company_name'
        },
        {
          text: 'MFO',
          value: 'mfo'
        },
        {
          text: 'ИНН',
          value: 'inn'
        },
        {
          text: 'PAYMO',
          value: 'seller_id'
        },
        {
          text: 'MyUzcard',
          value: 'uzcard_login'
        },
        {
          text: 'Телефон',
          value: 'phone'
        },
        {
          text: 'Адресс',
          value: 'address'
        },
        {
          text: 'Действие',
          value: 'action'
        }
      ],
      applyDeleteDialog: false
    }
  },
  methods: {
    async deleteConfirmHandle() {
      this.$showLoading()
      try {
        await this.$http.delete(`admin/mko/${this.selectedItem.id}`)
        this.items = this.items.filter(mko => {
          return mko.id !== this.selectedItem.id
        })
        this.$setSuccess({text: messages.onDelete})
      } catch (e) {
        this.$setResponseError({error: e})
      } finally {
        this.$clearLoading()
        this.selectedItem = null
      }
    },
    async changeBranchStatus(item) {
      item.loading = true
      try {
        await this.$http.post(`admin/mko/change-status/${item.id}`)
      } catch (e) {
        this.$setResponseError({error: e})
        if (item.user.status === 10) {
          item.user.status = 0
        } else {
          item.user.status = 10
        }
      } finally {
        item.loading = false
      }
    },
    async onChangeFilter() {
      try {
        let options = {...this.options, page: `${this.options.page}`}
        if (!shallowEqual({...this.$route.query}, options)) {
          await this.$router.replace({query: options})
        }
      } catch (e) {
        console.error(e)
      }
      this.$showLoading()
      await this.getItems()
      this.$clearLoading()
    },
    async getItems() {
      try {
        const {data: {data, links: {last_page}}} = await this.$http.get('admin/mko/branches', {
          params: {...this.options}
        })
        this.lastPage = last_page
        this.items = data.map(item => {
          item.loading = false
          return item
        })
      } catch (e) {
        this.$setResponseError({error: e})
      }
    },
    deleteItemHandler(item) {
      this.selectedItem = item
      this.deleteConfirmDialog = true
    },
    mkoEdit(id) {
      return {name: this.isUserSuperAdmin ? 'mko-edit' : 'mko-update', params: {id}}
    },
    deleteItem() {
      this.applyDeleteDialog = true
    },
  },
  computed: {
    ...mapGetters(['isUserSuperAdmin'])
  },
  async created() {
    const options = getObjectValuesByKey(this.options, this.$route.query)
    if (typeof options.page === 'string' && !isNaN(options.page)) options.page = +options.page
    this.options = options
    if (this.isUserSuperAdmin) {
      this.headers.splice(7, 0, {
        text: 'Заблокировать',
        value: 'status'
      })
    }
    this.$showLoading()
    await this.getItems()
    this.$clearLoading()
  }
}
</script>
